<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Yeni Bayi Oluştur</h4>
              <p class="card-category">Yeni bayi oluşturun.</p>



              <form class="m-5">
                <div class="row">
                  <div class="col-md-4">
                    <base-input type="number" label="Bayi Kodu" placeholder="Bayi Kodu" v-model="payload.code">
                    </base-input>
                  </div>


                  <div class="col-md-4">
                    <base-input type="text" label="Bayi Adı" placeholder="Bayi Adı" v-model="payload.title">
                    </base-input>
                  </div>

                  <div class="col-md-4">
                    <base-input type="text" label="Şehir" placeholder="Şehir" v-model="payload.city">
                    </base-input>
                  </div>

                </div>

                <div class="row pt-5">
                  <div class="col-md-12">
                    <label>Aktif Mi?</label>
                    <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="payload.isActive"
                      :checked="payload.isActive" @click="payload.isActive = !payload.isActive">
                    </base-checkbox>
                  </div>
                </div>






                <div class="text-center pt-5">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewDealer()">
                    Oluştur
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>

            </template>
          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      payload: {
        code: "",
        title: "",
        city: "",
        isActive: true
      }
    }
  },
  mounted() {
  },
  methods: {
    createNewDealer() {
      CollectionService.postWidthAuth('dealer', this.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Bayi Oluşturuldu")
          this.$router.push(`/admin/dealers`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },

  }
}
</script>
<style></style>